import IconClose from '@assets/icons/close.svg?react';
import IconSearch from '@assets/icons/search.svg?react';
import {
 Box,
 IconButton,
 InputBase,
 TextField,
 Theme,
 useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import customColors from '../../utils/customColors';
import { normalizeSearch } from '../../utils/stringUtils';

const FieldSearch = ({
 searchValue,
 setSearchValue,
 label,
 bordered = false,
}: {
 searchValue: string;
 setSearchValue: (value: string) => void;
 label: string;
 bordered?: boolean;
}) => {
 const { t } = useTranslation();
 const th = useTheme();
 return (
  <Box
   sx={{
    pr: bordered ? '8px 12px' : '4px',
    borderRadius: bordered ? '4px' : 0,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${customColors.lightestGray}`,
    ...(bordered && {
     border: `1px solid ${customColors.lightestGray}`,
    }),
   }}
  >
   <InputBase
    value={searchValue || ''}
    sx={{ ml: '12px', flex: 1, fontWeight: bordered ? 400 : 500 }}
    placeholder={label}
    inputProps={{ 'aria-label': label }}
    fullWidth
    onChange={(e) => {
     const nextValue = e.target.value;
     if (normalizeSearch(nextValue) === normalizeSearch(searchValue || '')) return;
     setSearchValue(nextValue);
    }}
    // slotProps={{
    //  input: {
    //   disableUnderline: true,
    //  },
    // }}
   />
   {/* <TextField
    size="small"
    value={searchValue || ''}
    label={label}
    variant="outlined"
    sx={{
     border: 0,
     '& .MuiInputBase-root': {
      backgroundColor: (theme: Theme) => theme.palette.kemek.white,
      border: 0,
     },
    }}
   /> */}

   <IconButton
    onClick={() => {
     if (!searchValue) return;
     if (normalizeSearch(searchValue) === '') return;
     setSearchValue('');
    }}
    sx={{ width: 24, height: 24, p: '4px', mr: '4px' }}
   >
    {searchValue ? (
     <IconClose
      style={{ color: th.palette.kemek.lightGray, width: 13, height: 13 }}
     />
    ) : (
     <IconSearch
      style={{ color: th.palette.kemek.lightGray, width: 13, height: 13 }}
     />
    )}
   </IconButton>
  </Box>
 );
};

export default FieldSearch;

